
  import { Component, Vue } from 'vue-property-decorator'

  import EventBus from '@/helpers/EventBus'

  @Component({ name: 'RequestCodeLink' })
  export default class extends Vue {
    onclick() {
      EventBus.$emit('request-code-link-clicked')
    }
  }
